
import { defineComponent } from 'vue'
import hemisphereService from '@/services/hemisphere.service'
import useVuelidate from '@vuelidate/core'
import { required, email } from '@/utils/i18n-validators'

export default defineComponent({
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      resetPasswordForm: {
        email: ''
      }
    }
  },
  validations() {
    return {
      resetPasswordForm: {
        email: {
          required,
          email
        }
      }
    }
  },
  computed: {
    isSubmitDisabled(): boolean {
      return this.v$.resetPasswordForm.$invalid
    }
  },
  methods: {
    async sendForgottenEmail() {
      this.v$.resetPasswordForm.$touch()
      if (this.v$.resetPasswordForm.$invalid) {
        return false // stop here if form is invalid
      } else {
        try {
          await hemisphereService.forgottenPassword(this.resetPasswordForm.email)
          this.$toast.add({
            severity: 'success',
            summary: this.$t('login-page.request-accepted'),
            detail: this.$t('login-page.check-mailbox'),
            life: 3000
          })
        } catch (error: any) {
          console.log(error)
          this.$toast.add({
            severity: 'error',
            summary: this.$t('validations.error-occured'),
            detail: error.response.data.message,
            life: 3000
          })
        }
      }
    }
  }
})
